import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_ADDRESS || "http://localhost:8083",
  headers: {
    "Content-type": "application/json"
  }
});

export default apiClient;